import { isEmpty } from '../utils/is-empty.js';
import { removeMarks } from '../utils/marks.js';

function withEmptyClearFormatting(editor) {
  const { onChange } = editor;
  editor.onChange = (options) => {
    if (isEmpty(editor, editor.children)) {
      removeMarks(editor);
    }
    onChange(options);
  };
  return editor;
}

export { withEmptyClearFormatting };
//# sourceMappingURL=empty-clear-formatting.js.map
